import { useEffect } from "react";
import { usePDF, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";

import ModulePdfOutputMain from "./output/main";

import { blobToFile } from "../../service/common";
import { saveAs } from "file-saver";

import { Button } from "primereact/button";

export function ModulePdfDownloadLink(props) {
  const { pdfType, pdfName } = props;

  return (
    <>
      <PDFDownloadLink document={<></>} fileName={`${pdfName}.pdf`}>
        {({ blob, url, loading, error }) =>
          loading ? "Loading document..." : "Download now!"
        }
      </PDFDownloadLink>
    </>
  );
}

export function ModulePdfExport(props) {
  const {
    className,
    btnLabel,
    pdfType,
    pdfName,
    optionData,
    patientData,
    isExport = true,
    finishAction,
    exportAction,
  } = props;
  const [instance] = usePDF({
    document: (
      <ModulePdfOutputMain pdfType={pdfType} patientData={patientData} />
    ),
  });

  useEffect(() => {
    if (!instance.loading) finishAction();
  }, [instance]);

  const exportPDF = () => {
    const fileName = `${pdfName}.pdf`;
    if (isExport) saveAs(instance.blob, fileName);
    exportAction({
      blob: instance.blob,
      file: blobToFile({ blob: instance.blob, fileName }),
    });
  };

  return (
    <>
      <Button
        className={className}
        type="button"
        label={btnLabel}
        onClick={() => exportPDF()}
      />
    </>
  );
}

export function ModulePdfView(props) {
  const { pdfType, optionData, patientData } = props;

  return (
    <>
      <PDFViewer
        width="100%"
        height="90%"
        style={{ border: "none" }}
        showToolbar={false}
      >
        <ModulePdfOutputMain pdfType={pdfType} patientData={patientData} />
      </PDFViewer>
    </>
  );
}
